import React from 'react';
import _get from 'lodash.get';
import { isApp } from 'utils/getParams';
import {
  loadNewsListingPageData,
  loadCardsInsert,
  loadElectionsListingPageData,
  loadYearWiseConstituencyData,
  loadBudgetoMeterData,
  loadYearWiseCandidatesData,
  loadStateConstNamesMapping,
  loadYearWiseScheduleData,
  loadYearWisePartyData,
  loadHallOfFameDetailPageData,
  loadOlympicsSportsDetailPageData,
  loadWUData,
} from 'routes/newslisting/redux';
import { commonHeadScripts } from 'helpers/scripts/headScripts';
import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import { loadLayoutDataList } from 'reduxUtils/modules_v2/layout';
import { updatePrebidFlag } from 'helpers/ads/redux';
import {
  getSiteConfig,
  updateCaimpaignAdsConfig,
} from 'reduxUtils/modules/common';
import Layout from 'components_v2/desktop/Layout';
import {
  getSectionsListFromBreadCrumb,
  getCustomDimension8,
  fireGA4Script,
} from 'utils/common';
import {
  getKeyvaluesNav,
  setAdsConfig,
  getUniqueKeywords,
  checkJarvisAdsConfigForSS,
} from 'helpers/ads/utils';
import NewsListing from './NewsListing';
import { getCardAPI } from '../config/cardconfig';
import {
  loadOtherBUListingWidgetData,
  loadLeadVideoFromVideosSection,
  MAGICBRICKS_BU,
} from '../../components/common/3rdPartyRowLayout/redux';
import s from './NewsListing.scss';
import { IMAGE_VERSION, TOI_LIVE_DOMAIN } from '../../../../constants';
import {
  // loadElectionData,
  loadExitPoll,
  loadResult,
} from '../../../../components/ElectionV2/redux';
import {
  loadLokSabhaElectionData,
  loadLokSabhaExitPoll,
  loadLokSabhaResult,
} from '../../../../components/ElectionV2/loksabha_redux';
import NewsV2Listing from './NewsV2Listing';

// import { NEWSLISTING_GA_CATEGORY } from '../../../../constants';
// import newslistdata from '../../data/newslisting.json';

const pageName = 'NewsListing';

async function action(context, subSection) {
  const dataPromiseArray = [];
  const isAppView = isApp(context.query);
  const localParams = { 0: context.path };

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState(),
    sectionsNameList = [],
    cd8 = '';

  // const { query: { geolocation } = {} } = context;
  const isPrime = !!state.isPrime;
  let listingPageName = '';

  const urlPath = context.pathname;
  if (urlPath) {
    const pathArr = urlPath.split('/');
    if (pathArr && pathArr.length > 0 && pathArr[1]) {
      listingPageName = pathArr[1];
    }
    if (
      pathArr &&
      pathArr.length > 3 &&
      pathArr[3] &&
      pathArr[3].includes('upcoming-match-schedule-and-results')
    ) {
      subSection.subsec2 = pathArr[3];
    }
  }
  const { pathname } = context;
  let secName = subSection.subsections ? subSection.subsections : '';
  const subsec2 = subSection.subsec2 ? subSection.subsec2 : '';
  const subsec2Path = subsec2 ? `/${subsec2}` : '';
  const subsec3 = subSection.subsec3 ? subSection.subsec3 : '';
  const subsec3Path = subsec3 ? `/${subsec3}` : '';
  const subsec4 = subSection.subsec4 ? subSection.subsec4 : '';
  const subsec4Path = subsec4 ? `/${subsec4}` : '';
  const subsec5 = subSection.subsec5 ? subSection.subsec5 : '';
  const subsec5Path = subsec5 ? `/${subsec5}` : '';
  const isConstituencyPage =
    listingPageName === 'elections' &&
    (subsec3 === 'constituency-show' ||
      subsec3 === 'constituencies-list' ||
      secName === 'candidates' ||
      secName === 'star-candidates' ||
      subsec3 === 'candidates' ||
      subsec3 === 'exit-polls' ||
      subsec2 === 'exit-polls' ||
      secName === 'exit-polls' ||
      subsec3 === 'results' ||
      subsec2 === 'results' ||
      secName === 'results' ||
      subsec2 === 'states' ||
      subsec2 === 'parties' ||
      subsec4 === 'candidateshow' ||
      secName === 'lok-sabha-election-schedule' ||
      secName === 'lok-sabha-constituencies');
  const isBudgetPage = secName === 'budget';
  const isHallOFFamePage = urlPath.includes('hall-of-fame-detail');
  const isOlympicSportsPage = urlPath.includes('olympics-sports-detail');

  // Needs to be removed once all pages in this category are tested and go live in this new structure.
  const validBoardUrls = [
    '/education/results/board-exam-results/mp-board-10th-result/109374548',
    '/education/results/board-exam-results/mp-board-12th-result/109374567',
    '/education/results/board-exam-results/wb-board-12th-result/109398428',
    '/education/results/board-exam-results/wb-board-10th-result/109398401',
    '/education/results/board-exam-results/rbse-rajasthan-board-10th-result/109063180',
    '/education/results/board-exam-results/rbse-rajasthan-board-12th-result/109063206',
    '/education/results/board-exam-results/upmsp-up-board-class-12th-result/109005657',
    '/education/results/board-exam-results/upmsp-up-board-class-10th-result/109005635',
  ];

  const boardResultMsid =
    !isHallOFFamePage && !isOlympicSportsPage && subSection && subSection.msid;
  const isBoardResultPage =
    context &&
    context.pathname &&
    validBoardUrls.includes(context.pathname) &&
    subsec3 &&
    boardResultMsid;

  if (
    listingPageName === 'elections' &&
    pathname.includes('-lok-sabha-election')
  ) {
    secName = `${secName}-lok-sabha-election`;
  }
  const newsListingV2 = ['mind-field'];
  const isNewsListingV2Page = newsListingV2.includes(secName);
  const newParams = {
    ...localParams,
    curpg: 1,
    fullPath:
      isHallOFFamePage || isOlympicSportsPage
        ? context.pathname
        : `/${listingPageName}${
            secName ? `/${secName}` : ''
          }${subsec2Path}${subsec3Path}${subsec4Path}${subsec5Path}`,
    isWapView: false,
    isAppView,
    isPrime,
    subSection,
    isConstituencyPage,
    isHallOFFamePage,
    isOlympicSportsPage,
    isStatePage:
      listingPageName === 'elections' &&
      (subsec3 === 'constituencies-list' ||
        (secName === 'lok-sabha-constituencies' && !subsec2)),
    useInternalFeed: context.pathname && context.pathname === '/city',
    boardResultMsid:
      boardResultMsid && isBoardResultPage ? boardResultMsid : '',
    isNewsListingV2Page,
  };

  if (isBoardResultPage) {
    newParams.fullPath = `/${listingPageName}/${secName}${subsec2Path}`;
  }

  const isCityHP =
    context.pathname && pathname.includes('/city') && !secName && !subsec2;

  const cardAPIPath = getCardAPI(newParams.fullPath);
  if (
    !state.newslisting.data &&
    !isConstituencyPage &&
    !isHallOFFamePage &&
    !isOlympicSportsPage
  ) {
    dataPromiseArray.push(
      context.store.dispatch(loadNewsListingPageData(newParams)),
    );
  }
  if (!state.newslisting.data && isHallOFFamePage && !isOlympicSportsPage) {
    dataPromiseArray.push(
      context.store.dispatch(loadHallOfFameDetailPageData(newParams)),
    );
  }

  if (!state.newslisting.data && isOlympicSportsPage && !isHallOFFamePage) {
    dataPromiseArray.push(
      context.store.dispatch(loadOlympicsSportsDetailPageData(newParams)),
    );
  }

  if (!state.newslisting.data && isConstituencyPage) {
    dataPromiseArray.push(
      context.store.dispatch(loadElectionsListingPageData(newParams)),
    );
  }

  if (!state.newslisting.budgetoMeter && isBudgetPage) {
    dataPromiseArray.push(
      context.store.dispatch(loadBudgetoMeterData(newParams)),
    );
  }

  if (!isAppView && (!state.header.data || !state.footer_v2.data)) {
    if (newParams.isHallOFFamePage) {
      newParams.fullPath = '/sports/paris-olympics-2024/hall-of-fame-detail';
    }
    if (newParams.isOlympicSportsPage) {
      newParams.fullPath = '/sports/paris-olympics-2024/olympics-sports-detail';
    }
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataList(newParams)),
    );
  }

  if (cardAPIPath && !state.newslisting.cardsInserts)
    dataPromiseArray.push(context.store.dispatch(loadCardsInsert(cardAPIPath)));

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  if (isCityHP && !state.otherbulisting.data) {
    await context.store.dispatch(loadOtherBUListingWidgetData(MAGICBRICKS_BU));
    dataPromiseArray.push(
      context.store.dispatch(
        loadLeadVideoFromVideosSection(MAGICBRICKS_BU, false),
      ),
    );
  }

  // Route data calls start
  // const contextParams = context.params;
  // Route data calls end

  // we need to serve 404 page in case of query parameter cfmid hence avoiding all redux calls
  if (!(context && context?.query?.cfmid)) {
    // wait for responses on server side
    if (typeof window === 'undefined') {
      await Promise.all(dataPromiseArray);
    }
  }
  // get updated state
  state = context.store.getState();
  // TODO: Election Widget
  IMAGE_VERSION.version = state.common?.siteConfig?.imageVersion || 1;

  if (
    state.newslisting.data &&
    state.newslisting.data.sectionitems &&
    Array.isArray(state.newslisting.data.sectionitems) &&
    state.newslisting.data.sectionitems.length &&
    state.newslisting.data.sectionitems.filter(
      section => section.id === 'election_widget',
    ).length > 0 &&
    !state?.lokSabhaElection?.refreshinterval
  ) {
    const loksabhaElectionUrl = state.common?.siteConfig?.loksabhaElectionUrl;
    await context.store.dispatch(
      loadLokSabhaElectionData(null, loksabhaElectionUrl, true),
    );
  }

  // const electionDataPromiseArray = [];

  // if (
  //   state.newslisting?.data?.sectionitems &&
  //   Array.isArray(state.newslisting?.data?.sectionitems) &&
  //   state.newslisting?.data?.sectionitems.length > 0 &&
  //   state.newslisting?.data?.sectionitems[0]?.id === 'election_main_widget'
  // ) {
  //   if (
  //     state.newslisting?.data?.sectionitems[0].tabs &&
  //     Array.isArray(state.newslisting?.data?.sectionitems[0].tabs) &&
  //     state.newslisting?.data?.sectionitems[0].tabs.length > 0
  //   ) {
  //     const assemblyElectionSelection = state.newslisting?.data?.sectionitems[0].tabs.filter(
  //       tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 2,
  //     );
  //     const lokSabhaElectionSelection = state.newslisting?.data?.sectionitems[0].tabs.filter(
  //       tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 1,
  //     );
  //     if (
  //       assemblyElectionSelection &&
  //       Array.isArray(assemblyElectionSelection) &&
  //       assemblyElectionSelection.length > 0 &&
  //       !state?.electionV2?.refreshinterval
  //     ) {
  //       const assemblyElectionUrl =
  //         state.common?.siteConfig?.assemblyElectionUrl;
  //       electionDataPromiseArray.push(
  //         context.store.dispatch(
  //           loadElectionData(null, assemblyElectionUrl, false),
  //         ),
  //       );
  //     }
  //     if (
  //       lokSabhaElectionSelection &&
  //       Array.isArray(lokSabhaElectionSelection) &&
  //       lokSabhaElectionSelection.length > 0 &&
  //       !state?.lokSabhaElection?.refreshinterval
  //     ) {
  //       const loksabhaElectionUrl =
  //         state.common?.siteConfig?.loksabhaElectionUrl;
  //       electionDataPromiseArray.push(
  //         context.store.dispatch(
  //           loadLokSabhaElectionData(null, loksabhaElectionUrl, false),
  //         ),
  //       );
  //     }
  //   }
  // }

  // if (typeof window === 'undefined') {
  //   await Promise.all(electionDataPromiseArray);
  // }

  state = context.store.getState();

  const checkAndLoadData = async (
    sectionID,
    urlName,
    loadMethod,
    loadMethodDataKey = '',
    searches = null,
  ) => {
    if (
      state.newslisting.data &&
      state.newslisting.data.sectionitems &&
      !(
        state.newslisting.filteredData ||
        state?.electionV2?.refreshinterval ||
        state?.lokSabhaElection?.refreshinterval
      ) &&
      Array.isArray(state.newslisting.data.sectionitems) &&
      state.newslisting.data.sectionitems.length &&
      state.newslisting.data.sectionitems.filter(
        section => section.id === sectionID,
      ).length > 0
    ) {
      const data = state.newslisting.data.sectionitems.filter(
        section => section.id === sectionID,
      );
      let latestYear = 0;
      let latestYearData = null;
      if (data && Array.isArray(data) && data.length && data[0].items) {
        const { electionData } = data[0].items;
        // eslint-disable-next-line no-restricted-syntax
        for (const year in electionData) {
          if (
            electionData[year].year > latestYear &&
            electionData[year]?.[urlName]
          ) {
            latestYear = electionData[year].year;
            latestYearData = electionData[year];
          }
        }
        if (!loadMethodDataKey) {
          if (!searches?.sn) {
            await context.store.dispatch(loadMethod(latestYearData));
          } else if (searches?.sn) {
            await context.store.dispatch(
              loadMethod(
                latestYearData,
                searches,
                { alpha: 1, key: 'cns_name' },
                false,
                true,
              ),
            );
          }
        } else if (loadMethodDataKey) {
          await context.store.dispatch(
            loadMethod(latestYearData?.[loadMethodDataKey]),
          );
        }
      }
    }
  };

  await checkAndLoadData(
    'exitpoll',
    'exitPollUrl',
    loadExitPoll,
    'exitPollObject',
  );

  await checkAndLoadData('result', 'resultUrl', loadResult, 'exitPollObject');

  await checkAndLoadData(
    'loksabha_result',
    'resultUrl',
    loadLokSabhaResult,
    'exitPollObject',
  );

  await checkAndLoadData(
    'loksabha_state_result',
    'resultUrl',
    loadLokSabhaResult,
    'exitPollObject',
  );

  await checkAndLoadData(
    'loksabha_states',
    'resultUrl',
    loadLokSabhaResult,
    'exitPollObject',
  );

  await checkAndLoadData('loksabha_parties', 'partyUrl', loadYearWisePartyData);

  await checkAndLoadData(
    'loksabha_exitpoll',
    'exitPollUrl',
    loadLokSabhaExitPoll,
    'exitPollObject',
  );

  if (secName !== 'assembly-elections') {
    await checkAndLoadData(
      'consistuencies_results',
      'url',
      loadYearWiseConstituencyData,
      '',
      { sn: subsec2 },
    );
  } else {
    await checkAndLoadData(
      'consistuencies_results',
      'url',
      loadYearWiseConstituencyData,
    );
  }

  await checkAndLoadData(
    'loksabha_schedule',
    'scheduleUrl',
    loadYearWiseScheduleData,
  );

  if (
    state.newslisting.data &&
    state.newslisting.data.sectionitems &&
    !state.newslisting.filteredData &&
    Array.isArray(state.newslisting.data.sectionitems) &&
    state.newslisting.data.sectionitems.length &&
    state.newslisting.data.sectionitems.filter(
      section => section.id === 'candidates',
    ).length
  ) {
    const data = state.newslisting.data.sectionitems.filter(
      section => section.id === 'candidates',
    );
    let latestYear = 0;
    let latestYearData = null;
    if (data && Array.isArray(data) && data.length && data[0].items) {
      const { electionData } = data[0].items;
      // eslint-disable-next-line no-restricted-syntax
      for (const year in electionData) {
        if (
          electionData[year].year > latestYear &&
          electionData[year].candidatesUrl
        ) {
          latestYear = electionData[year].year;
          latestYearData = electionData[year];
        }
      }
      await context.store.dispatch(
        loadYearWiseCandidatesData(
          latestYearData.candidatesUrl,
          latestYearData,
          latestYearData.loksabha && subsec2 ? { sn: subsec2 } : [],
          { alpha: 1, key: latestYearData.loksabha ? 'seonm' : 'cn' },
          false,
          !!(latestYearData.loksabha && subsec2),
          false,
        ),
      );
      if (latestYearData.mappingUrl) {
        await context.store.dispatch(
          loadStateConstNamesMapping(latestYearData.mappingUrl, subsec2),
        );
      }
    }
  }

  if (
    state.newslisting.data &&
    state.newslisting.data.sectionitems &&
    !state.newslisting.filteredData &&
    Array.isArray(state.newslisting.data.sectionitems) &&
    state.newslisting.data.sectionitems.length &&
    state.newslisting.data.sectionitems.filter(
      section => section.id === 'star_candidates',
    ).length
  ) {
    const data = state.newslisting.data.sectionitems.filter(
      section => section.id === 'star_candidates',
    );
    let latestYear = 0;
    let latestYearData = null;
    if (data && Array.isArray(data) && data.length && data[0].items) {
      const { electionData } = data[0].items;
      // eslint-disable-next-line no-restricted-syntax
      for (const year in electionData) {
        if (
          electionData[year].year > latestYear &&
          electionData[year].starCandidatesUrl
        ) {
          latestYear = electionData[year].year;
          latestYearData = electionData[year];
        }
      }
      await context.store.dispatch(
        loadYearWiseCandidatesData(
          latestYearData.starCandidatesUrl,
          latestYearData,
          [],
          { alpha: 1, key: 'seonm' },
          false,
          false,
          true,
        ),
      );
      if (latestYearData.mappingUrl) {
        await context.store.dispatch(
          loadStateConstNamesMapping(latestYearData.mappingUrl),
        );
      }
    }
  }

  const dataURLPages = [
    'budget_history',
    'budget_rupee_flow',
    'trump_harris',
    'president_timeline',
  ];

  if (
    state.newslisting.data &&
    state.newslisting.data.sectionitems &&
    Array.isArray(state.newslisting.data.sectionitems) &&
    state.newslisting.data.sectionitems.length &&
    state.newslisting.data.sectionitems.filter(section =>
      dataURLPages.includes(section.id),
    ).length
  ) {
    const data = state.newslisting.data.sectionitems.filter(section =>
      dataURLPages.includes(section.id),
    );
    if (
      data &&
      Array.isArray(data) &&
      data.length &&
      data[0].id &&
      !data[0].items
    ) {
      await context.store.dispatch(loadWUData(data[0].dataUrl, data[0].id));
    }
  }

  state = context.store.getState();

  let seoData = _get(state, 'newslisting.data.seo');
  if (
    pathname &&
    (pathname.includes('/world/') || pathname.includes('/candidateshow/'))
  ) {
    if (seoData) {
      seoData.schema = _get(state, 'newslisting.data.schema');
    }
  }
  if (_get(state, 'navigation.data.breadCrumb', undefined)) {
    sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation.data.breadCrumbs,
    );
    cd8 = getCustomDimension8(sectionsNameList);
  }

  let status = 200;
  const title = 'Get Latest News Updates from Times Of India';
  let dataAvailable = !!state.newslisting.data;

  let redirect = false;
  if (isConstituencyPage && state?.newslisting?.data?.redirectUrl) {
    status = 301;
    redirect = state?.newslisting?.data?.redirectUrl;
  }

  if (
    isConstituencyPage &&
    !(
      (state?.newslisting?.filteredData &&
        Array.isArray(state.newslisting.filteredData) &&
        state.newslisting.filteredData.length > 0) ||
      state?.electionV2?.refreshinterval ||
      state?.newslisting?.latestYearData ||
      (secName === 'lok-sabha-election-schedule' &&
        state?.newslisting?.filteredData) ||
      subsec4 === 'candidateshow' ||
      state?.lokSabhaElection?.refreshinterval
    )
  ) {
    dataAvailable = false;
  }
  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }
  if (
    context &&
    context.pathname &&
    context.pathname.includes('/sports/cricket/ipl/teams') &&
    typeof window === 'undefined'
  ) {
    status = 404;
  }

  if (
    context &&
    context.pathname &&
    !validBoardUrls.includes(context.pathname) &&
    boardResultMsid
  ) {
    status = 404;
    dataAvailable = false;
    if (seoData && typeof seoData === 'object') {
      seoData = {};
      seoData.noindexnofollow = true;
    }
  }

  if (typeof window !== 'undefined') {
    if (subsec3) {
      window.categoryForGA = `WEB-AL-${listingPageName}-${subsec3}`;
    } else if (subsec2) {
      window.categoryForGA = `WEB-AL-${listingPageName}-${subsec2}`;
    } else {
      window.categoryForGA = `WEB-AL-${listingPageName}${
        secName ? `-${secName}` : ''
      }`;
    }
    if (secName === 'financial-calculators') {
      window.categoryForGA = window.categoryForGA.replace('WEB-AL', 'WEB-CL');
    }
    window.categoryForSearchGA = `WEB-TOI-CL-${listingPageName}`;
    setAdsConfig({ subSection: secName });
  }

  let gaCategory;
  if (subsec3) {
    gaCategory = `WEB-AL-${listingPageName}-${subsec3}`;
  } else if (subsec2) {
    gaCategory = `WEB-AL-${listingPageName}-${subsec2}`;
  } else {
    gaCategory = `WEB-AL-${listingPageName}${secName ? `-${secName}` : ''}`;
  }

  if (secName === 'financial-calculators') {
    gaCategory = gaCategory.replace('WEB-AL', 'WEB-CL');
  }
  // key value targetting for ads
  const getAdsTargetingObj = () => {
    const contextURL = `${TOI_LIVE_DOMAIN}${context.pathname}`;
    const contentUrl = _get(state, 'wu') || contextURL;
    const metaKeywords = getUniqueKeywords(
      _get(state, 'newslisting.data.seo.news_keywords', undefined),
      _get(state, 'newslisting.data.seo.keywords', undefined),
    );
    const navSubsecs = _get(state, 'newslisting.data.navsubsecs');
    const navKeyObj = getKeyvaluesNav(navSubsecs, contentUrl);
    const adConfig = {
      Tmpl_SCN: 'Listing',
      Channel: 'toi',
      ...navKeyObj,
    };

    return {
      Meta_Keywords: metaKeywords,
      Content_URL: contentUrl,
      Hyp1: _get(state, 'newslisting.data.specialID'),
      ...adConfig,
    };
  };
  const adsTargetingObj = getAdsTargetingObj();
  let sSjConf = null;
  if (!isPrime) {
    //  && (isCityHP || isBusinessHP)
    // TOdo we will remove as soon as  all pages got migrated to jarvis adcodes
    let isActive = false;
    let isGroupActive = false;
    if (context.pathname) {
      // only secL1 is handle
      const list = ['/india/'];
      const groupSection = [
        '/business',
        '/world',
        '/sports',
        '/education',
        '/astrology',
        '/city',
        '/elections/news',
      ];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of list) {
        if (pathname.includes(item)) {
          isActive = true;
          break;
        }
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const item of groupSection) {
        if (pathname.includes(item)) {
          isGroupActive = true;
          break;
        }
      }
    }
    const jarvisConfig = _get(state, 'common.siteConfig.revenue', {});
    const webInter = _get(jarvisConfig, 'webInterstitial.ros', null);
    if (webInter) {
      const webInterstitial = {
        ...jarvisConfig.webInterstitial,
        ...webInter,
      };
      sSjConf = { webInterstitial };
    }
    if (typeof window === 'undefined') {
      const caimpaignConfig = checkJarvisAdsConfigForSS({
        jarvisConfig,
        isWapView: false,
        pathname: context?.pathname,
        ...adsTargetingObj,
      });
      context.store.dispatch(updateCaimpaignAdsConfig(caimpaignConfig));
    }
    const activeL2Pages = [
      '/india/ayodhya-ram-mandir',
      '/business/personal-finance',
    ];
    const oldCheck =
      (!secName || activeL2Pages.includes(pathname)) && !subsec2 && isActive;
    if (
      typeof window === 'undefined' &&
      (oldCheck || isGroupActive || isConstituencyPage)
    ) {
      await context.store.dispatch(loadPageAdCode(adsTargetingObj, 'web'));
      // get updated state
      state = context.store.getState();
    }
  }
  const hypVals = _get(
    state,
    'common.siteConfig.revenue.revenue_section.hyp1Vals',
    [],
  );
  const revWidgets = _get(state, 'revenue.data.widgets', {});
  let showMiniTv = !_get(revWidgets, 'skipminitv', false);
  let hideAdCude = _get(revWidgets, 'skipcube', false);
  // let fifaPageCache = false;

  if (
    (pathname && pathname.includes('/education/upskill')) ||
    isBoardResultPage
  ) {
    showMiniTv = false;
    hideAdCude = true;
  }
  if (adsTargetingObj && hypVals.includes(adsTargetingObj.Hyp1)) {
    showMiniTv = false;
    hideAdCude = true;
  }
  // end key value targetting for ads
  const getComponent = pageTitle => {
    if (typeof window === 'undefined' && !dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
        </div>
      );
    }

    const prebidObj = _get(
      state,
      `common.siteConfig.prebid.templates.coronavirus.web`,
    );
    const pageRefreshTime = _get(
      state,
      `common.siteConfig.abexperiment.pagerefresh.refreshminutes.newlisting`,
      0,
    );

    context.store.dispatch(updatePrebidFlag(prebidObj));

    let mastheadImageLogo = '';
    if (
      context.pathname &&
      context.pathname.includes('/gadgets-news/times-techies')
    ) {
      mastheadImageLogo = '104858780';
    }
    const minitvLoadType = _get(
      state,
      'revenue.data.widgets.minitv.loadType',
      '',
    );
    const isInPageDock = minitvLoadType === 'content';
    if (isInPageDock) {
      showMiniTv = false;
    }

    return (
      <Layout
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        adPosition="masthead"
        pageType="newslisting"
        showMiniTv={showMiniTv && !isInPageDock}
        hideAdCude={hideAdCude}
        miniTvV2
        overRideClass={s.miniTvtopband}
        // hideAdBlockerDetector //comment this to add adblocker
        desktopAdCode={_get(
          state,
          'revenue.data.ads.layout.masthead',
          undefined,
        )}
        gutterAdCode={_get(state, 'revenue.data.ads.layout.gutter', undefined)}
        mastheadImageLogo={mastheadImageLogo}
      >
        {isNewsListingV2Page ? (
          <NewsV2Listing
            hpData={state.newslisting.data}
            navigation={state.header.data && state.header.data.navigation}
            isPrime={state.isPrime}
            campaigns={_get(state, 'common.siteConfig.revenue', '')}
            autherDetail={seoData?.description}
          />
        ) : (
          <NewsListing
            // newsData={state.newslisting && state.newslisting.data}
            subSection={subSection}
            cardsInserts={state.newslisting && state.newslisting.cardsInserts}
            gaCategory={gaCategory}
            location={context.pathname}
            refreshTime={parseFloat(pageRefreshTime, 10)}
            isCityHP={isCityHP}
            isInPageDock={isInPageDock}
            isBoardResultPage={isBoardResultPage}
            boardResultMsid={boardResultMsid}
          />
        )}
        {/* <NewsListing newsData={newslistdata} /> */}
      </Layout>
    );
  };
  if (typeof window !== 'undefined') {
    fireGA4Script();
  }
  const isNewGam = _get(revWidgets, 'isNewGam', false);
  const afterAdsScript = [];
  if (
    (context.pathname &&
      (context.pathname ===
        '/education/results/board-exam-results/bihar-board-bseb-class-12th-intermediate-result' ||
        context.pathname ===
          '/education/results/board-exam-results/bihar-board-bseb-class-10th-matric-result')) ||
    isBoardResultPage
  ) {
    afterAdsScript.push(
      `${TOI_LIVE_DOMAIN}/html_to_pdf/minify-1,version-1.cms`,
      `${TOI_LIVE_DOMAIN}/jspdf/minify-1,version-1.cms`,
    );
  }
  const d3ChartScripts =
    secName === 'modi-meter'
      ? [
          <script
            src="https://timesofindia.indiatimes.com/d3v4min.cms"
            type="text/javascript"
            id="d3chart_sdk_js"
          />,
        ]
      : [];

  return {
    title,
    chunks: ['newslistingdesktop'],
    seoData,
    status,
    redirect,
    component: getComponent(title),
    maxAge: 300,
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
    },
    preconnectDomains: ['//tpapi.timespoints.com'],
    headTags: [...commonHeadScripts, ...d3ChartScripts],
    isPrime: state.isPrime,
    adsTargetingObj,
    firstfoldColumbiaJs: true,
    enableInterstitial: !!sSjConf,
    jarvisAdsConfig: sSjConf,
    isNewGam,
    skipColumbiaScript: _get(revWidgets, 'skipCTN', false),
    afterAdsScript,
  };
}

export default action;
